import React from 'react';
import Frame from "../../images/about/paint.jpg";
import Fadeup from '../fadeup/Fadeup';
import Logo from "../../images/logo/logo.png";

function AboutBanner() {
  return (
    <section className='sec_pd'>
      <div className="mt-5">
<div className="row align-items-center   gap-4">
  {/* Left Side - Image */}
  <div className="col-md-5 d-flex justify-content-center">
    {/* <img 
      src={Frame} 
      alt="About Us" 
      className="about_img" 
      style={{ maxWidth: '70%', height: 'auto' }}
    /> */}
    <img src={Logo} alt="logo " className="about_img"  style={{ maxWidth: '70%', height: 'auto' }} />
  </div>
  
  {/* Right Side - Content */}
  <div className="col-md-6">
  <Fadeup delay={0.3}>
  <h3 className="text-start mb-4  text-black border-bottom pb-2">Welcome To Anachronistic</h3>
    <h4 className=" text-dark mb-4">About Our Company</h4>
    </Fadeup>
    <Fadeup delay={0.2}>
    <h4 className="text-black fs-5 ">
    Founded on a deep reverence for art and antiquity, Anachronistic Auction House has
    established itself as a premium destination for the sale and acquisition of unique, era-
    spanning collectibles. From Renaissance paintings to 20th-century memorabilia, our team
    curates each collection with meticulous care and historical insight. We champion authenticity,
    integrity, and passion in every transaction.
    </h4>
    
  </Fadeup>
  <Fadeup delay={0.2}>
    <h4 className=" text-dark my-4">About Our owner</h4>
    </Fadeup>
    <Fadeup delay={0.2}>
    <h4 className="text-black fs-5 ">
    [Bapatla N Rao], Founder &amp; Principal Curator
    A lifelong enthusiast of classical art and obscure collectibles, [Bapatla N Rao] launched
    Anachronistic Auction House with a vision to revive the grandeur and storytelling of
    traditional auctions. With academic grounding in art history and over 15 years in private
    collection curation, their leadership fosters a rich, ethical, and immersive auction experience.
    </h4>
    
  </Fadeup>
  </div>
</div>
</div>
    </section>
  );
}

export default AboutBanner;